module.exports = __webpack_public_path__ + "img/exclamation-mark.731f30c8.svg";